// Enum for schedule item status values
export const SCHEDULE_ITEM_STATUS = {
  UNAVAILABLE: "unavailable",
  AVAILABLE: "available", 
  CONSULTATION: "consultation",
  STANDARD_EXCEPTION: "standard-exception",
  RECURRING_EXCEPTION: "recurring-exception"
};
